import './TipsPickupCalibration.scss';
import {useDispatch, useSelector} from 'react-redux';
import {changeView} from 'stores/actions/appStateAction';
import {getPreviousAppViewMode} from 'stores/selectors/appStateSelectors';

import TipsPickupCalibrationHeader from './TipsPickupCalibrationHeader';
import TipsPickupCalibrationResultAndGuide from './TipsPickupCalibrationResultAndGuide';
import {
  runAutoA1OffsetCalibrationAndShowLoading,
  showA1OffsetCalibrationConfirmationModal,
} from './TipsPickupCalibrationBusiness';

function TipsPickupCalibration() {
  const dispatch = useDispatch();

  const previousViewMode = useSelector(getPreviousAppViewMode);

  const onClickAutoCalibration = () => {
    const callback = () => dispatch(runAutoA1OffsetCalibrationAndShowLoading());

    dispatch(showA1OffsetCalibrationConfirmationModal(callback));
  };

  const onCloseCalibration = () => dispatch(changeView(previousViewMode));

  return (
    <div className="tips-pickup-calibration-page">
      <TipsPickupCalibrationHeader onAutoCalibration={onClickAutoCalibration} onCloseCalibration={onCloseCalibration} />
      <div className="tips-pickup-calibration-page__results-container">
        <TipsPickupCalibrationResultAndGuide />
      </div>
    </div>
  );
}

export default TipsPickupCalibration;
